/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasonplaceholder3Inputs */

const en_coinvestments_declinedeal_reasonplaceholder3 = /** @type {(inputs: Coinvestments_Declinedeal_Reasonplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reason`)
};

/**
* | output |
* | --- |
* | "Select a reason" |
*
* @param {Coinvestments_Declinedeal_Reasonplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasonplaceholder3 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasonplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasonplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasonplaceholder3(inputs)
});
export { coinvestments_declinedeal_reasonplaceholder3 as "coInvestments_declineDeal_reasonPlaceholder" }